/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEvent
 */
export interface CreateEvent {
    /**
     * If always, the integration will subscribe to create events by default.
     * @type {string}
     * @memberof CreateEvent
     */
    enabled?: CreateEventEnabledEnum;
}


/**
 * @export
 */
export const CreateEventEnabledEnum = {
    Always: 'always'
} as const;
export type CreateEventEnabledEnum = typeof CreateEventEnabledEnum[keyof typeof CreateEventEnabledEnum];


/**
 * Check if a given object implements the CreateEvent interface.
 */
export function instanceOfCreateEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateEventFromJSON(json: any): CreateEvent {
    return CreateEventFromJSONTyped(json, false);
}

export function CreateEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function CreateEventToJSON(value?: CreateEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

